import { Outlet } from "react-router-dom";
import { IntercomProvider } from "react-use-intercom";
import { RelativeComponentLoader } from "../../components/loader";
import { Header } from "./Header";
import { Sidebar } from "./sidebar";
import IntercomChatBoot from "../intercom/IntercomChat";
import { INTERCOM_APP_ID, ENV } from "../../config";
import { getTenant } from "../../helpers/tenant";
import { useAppDispatch, useAppState } from "@/modules/app/useAppContext";
import { VersionChecker } from "../../components/versionCheck";
import { SidebarProvider, SidebarInset } from "@altimateai/lego";
import { setSidebarExpanded } from "@/modules/app/appSlice";
import { cn } from "@/lib/utils";
import { usePlaygroundRoute } from "@/modules/playground/hooks/usePlaygroundRoute";
import { BreadcrumbsProvider } from "@/components/breadcrumbs";

const Home = () => {
  const tenant = getTenant();
  const { rbacEnabled, userGroupsLoaded, sidebarExpanded } = useAppState();
  const dispatch = useAppDispatch();

  usePlaygroundRoute();

  const isReady = rbacEnabled ? userGroupsLoaded : true;

  const handleOpenChange = (open: boolean) => {
    dispatch(setSidebarExpanded(open));
  };

  return (
    <IntercomProvider appId={INTERCOM_APP_ID ?? ""} autoBoot={false}>
      <IntercomChatBoot tenant={tenant} env={ENV ?? ""} />
      <VersionChecker />
      <BreadcrumbsProvider>
        <SidebarProvider
          open={sidebarExpanded}
          onOpenChange={handleOpenChange}
          className="al-h-screen"
          expandOnHover
          overlayOnHover
        >
          <Sidebar />
          <SidebarInset className="al-min-w-0">
            <Header />
            <div
              id="altimate_main"
              className={cn("al-flex-1 al-overflow-y-auto al-bg-gray-100 al-p-8")}
              style={{ scrollbarGutter: "stable" }}
            >
              {!isReady ? <RelativeComponentLoader label="Loading..." /> : <Outlet />}
            </div>
          </SidebarInset>
        </SidebarProvider>
      </BreadcrumbsProvider>
    </IntercomProvider>
  );
};

export { Home };
